/* detect-file.js — ported VERBATIM from code.txt (lines 198-200, 279-326). Do not edit formulas:
   plan.md §12 pins them with golden tests. */

export const H = s => String(s || "").toLowerCase().replace(/[^a-z ]/g, "").trim();
export const pickCol = (headers, names) => { const hs = headers.map(H); for (const n of names) { const i = hs.indexOf(n); if (i >= 0) return headers[i]; } for (const n of names) { const i = hs.findIndex(h => h.includes(n)); if (i >= 0) return headers[i]; } return null; };
export const num = v => { if (v == null) return 0; const n = parseFloat(String(v).replace(/[%,\s]/g, "")); return isNaN(n) ? 0 : n; };

export function detectFile(rows, headers, name, famHint) {
  // Precedence: explicit folder/file name > column evidence > the upload section it was dropped into.
  // A file with Clicks/CTR/Position is traditional no matter which zone received it.
  const nameFam = /generative|gen[-_ ]?ai/i.test(name || "") ? "ai" : /performance|search[-_ ]results/i.test(name || "") ? "trad" : null;
  const fam = nameFam;
  const cQuery = pickCol(headers, ["top queries", "query", "queries", "search query"]);
  const cPage = pickCol(headers, ["top pages", "page", "url", "landing page", "address"]);
  const cDate = pickCol(headers, ["date", "day"]);
  const cImp = pickCol(headers, ["impressions"]);
  const cClicks = pickCol(headers, ["clicks"]);
  const cPos = pickCol(headers, ["position", "avg position", "average position", "avg pos"]);

  const SKIP = { kind: "extra", error: "Skipped — this export isn't needed for the analysis." };
  if (nameFam === "ai" && cQuery) return SKIP; // the Generative AI report has no query data
  if (cQuery && cImp) {
    const byQ = new Map();
    rows.forEach(r => {
      const q = String(r[cQuery] || "").replace(/\s+/g, " ").trim().toLowerCase(); if (!q) return;
      const imp = num(r[cImp]);
      const c = byQ.get(q) || { clicks: 0, imp: 0, posW: 0 };
      c.clicks += cClicks ? num(r[cClicks]) : 0; c.imp += imp; c.posW += (cPos ? num(r[cPos]) : 0) * imp; byQ.set(q, c);
    });
    const data = [...byQ].map(([q, v]) => ({ query: q, clicks: Math.round(v.clicks), impressions: Math.round(v.imp), position: v.imp ? +(v.posW / v.imp).toFixed(1) : 0 }));
    return { kind: "queries", data };
  }
  if (cPage && cImp) {
    const byP = new Map();
    rows.forEach(r => {
      const page = String(r[cPage] || "").trim(); if (!page) return;
      const imp = num(r[cImp]);
      const cur = byP.get(page) || { imp: 0, clicks: 0, posW: 0 };
      cur.imp += imp; cur.clicks += cClicks ? num(r[cClicks]) : 0; cur.posW += (cPos ? num(r[cPos]) : 0) * imp; byP.set(page, cur);
    });
    const arr = [...byP].map(([pg, v]) => ({ page: pg, imp: Math.round(v.imp), clicks: Math.round(v.clicks), pos: v.imp && v.posW ? +(v.posW / v.imp).toFixed(1) : 0 }));
    if (nameFam === "ai") return { kind: "aiPages", data: arr.map(x => ({ page: x.page, imp: x.imp })) };
    if (cClicks || cPos) return { kind: "tradPages", data: arr };
    if (nameFam === "trad" || famHint === "trad") return { kind: "tradPages", data: arr };
    return { kind: "aiPages", data: arr.map(x => ({ page: x.page, imp: x.imp })) }; // impressions-only page list = the AI export shape
  }
  if (nameFam === "trad" && cDate) return SKIP; // the traditional daily chart isn't used
  if (cDate && cImp && (nameFam === "ai" || (!cClicks && !cPos))) {
    const byD = new Map();
    rows.forEach(r => { const d = String(r[cDate] || "").slice(0, 10); if (!d) return; byD.set(d, (byD.get(d) || 0) + num(r[cImp])); });
    return { kind: "aiDaily", data: [...byD].map(([d, v]) => ({ d, v })).sort((a, b) => (a.d < b.d ? -1 : 1)) };
  }
  return SKIP;
}

